import { FC } from 'react';
import {
    List,
    ListItemButton,
    ListItemText
  } from '@mui/material';
  import { Link, useLocation } from 'react-router-dom';
  import { fileStructure } from '../FileStructure';
  import { renderSections } from './renderSections';
  
  export interface SectionState {
    [section: string]: boolean;
  }
  
  interface NavigationListProps {
    sectionState: SectionState;
    toggleSection: (section: string) => void;
  }
  
  const NavigationList: FC<NavigationListProps> = ({ sectionState, toggleSection }) => {
    const { pathname } = useLocation();
  
    return (
      <List>
        <li>
          <Link className="route-links" to="/">
            <ListItemButton selected={'/' === pathname}>
              <ListItemText primary="Report Home" />
            </ListItemButton>
          </Link>
        </li>

        {renderSections(fileStructure, 0, sectionState, toggleSection)}
      </List>
    );
  };
  export default NavigationList;
  